export default __webpack_public_path__ + "static/media/furniture10.22651ecb.jpeg";